<div class="row p-0">
	<div class="col-4 mt-3 ml-auto">
		<!-- <select id="locationFilter" class="ml-2 mt-2 form-control custom-location-select shadow-sm"
			[(ngModel)]="selectedLoc" (ngModelChange)="applyLocationFilter($event)">
			<option value="">All Locations</option>
			<option *ngFor="let loc of locations" [value]="loc.loccode">
				{{ loc.loccode }} - {{ loc.locationname }}
			</option>
		</select> -->
		<div class="alert alert-info mt-2 mb-0 p-2 small shadow-sm">
			This report reflects inventory for the <strong>main warehouse only</strong>.
		</div>
	</div>

	<div class="col-8 text-right ml-auto mr-0">
		<button class="mt-3 btn btn-sm btn-success" (click)="exportXls()" [disabled]="exporting">
			<i *ngIf="!exporting" class="fa fa-file-excel-o"></i>
			<i *ngIf="exporting" class="fa fa-spinner fa-spin"></i>
		</button>
		&nbsp;&nbsp;
		<button class="mt-3 btn btn-sm btn-danger" (click)="exportPdf()" [disabled]="exporting">
			<i *ngIf="!exporting" class="fa fa-file-pdf-o"></i>
			<i *ngIf="exporting" class="fa fa-spinner fa-spin"></i>
		</button>
	</div>
</div>

<div class="table" *ngIf="!loading; else loadingSpinner" #print_table>
	<table class="mt-3 table table-hover table-striped">
		<thead class="sticky-top thead-dark">
			<tr>
				<th scope="col">#</th>
				<th scope="col">Item ID</th>
				<th scope="col">Description</th>
				<th scope="col">Quantity</th>
				<th scope="col" class="noprint">Actions</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of filteredNeedBinItems; let i = index">
				<th scope="row" [innerHTML]="i + 1"></th>
				<td [innerHTML]="item.stockid"></td>
				<td [innerHTML]="item.description"></td>
				<td [innerHTML]="item.qoh" [ngClass]="{'text-danger font-weight-bold': item.qoh < 0}"></td>
				<td class="noprint">
					<a [routerLink]="'/inventory/view/' + item.stockid" [innerHTML]="'View'"></a>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<ng-template #loadingSpinner>
	<div class="text-center mt-5 mb-5">
		<i class="fa fa-spinner fa-spin fa-2x"></i>
		<p>Loading items...</p>
	</div>
</ng-template>